import React from 'react';
import { Logo } from './Logo';
import { getWhatsAppLink } from '../utils/whatsapp';
const FOOTER_WHATSAPP_MESSAGE = 'Hola, equipo de Origen Studio. Quiero conocer más sobre sus sistemas digitales.';
const sistemasLinks = [{
  href: '#sistemas',
  label: 'Presencia Digital'
}, {
  href: '#precios',
  label: 'Automatización'
}, {
  href: '#sistemas',
  label: 'Sistema Completo'
}, {
  href: '#voice',
  label: 'VOICE'
}];
const origenLinks = [{
  href: '#como-funciona',
  label: 'Cómo funciona'
}, {
  href: '#precios',
  label: 'Precios'
}];
export function Footer() {
  return <footer className="bg-carbon text-arena pt-12 md:pt-16 px-6 md:px-20 pb-12 md:pb-16" data-id="element-13" data-mp="3lec768pb9yd8">
      <div className="max-w-[1200px] mx-auto" data-id="element-14" data-mp="3qdf4f6z1v0an">
        <div className="flex flex-col md:flex-row justify-between gap-12 md:gap-24 mb-16" data-id="element-15" data-mp="3qcdp2qb03rn4">
          {/* Left Column */}
          <div className="flex-1" data-id="element-16" data-mp="29xvpe8qab5n7">
            <div className="mb-4" data-id="element-17" data-mp="2ey9wnok2abk6">
              <Logo variant="dark" data-id="element-18" data-mp="2ezb9nykn184j" />
            </div>
            <p className="font-body text-[14px] text-arena/55 max-w-[360px] leading-relaxed" data-id="element-19" data-mp="3l9k4zam1djc8">
              Sistemas digitales para empresas.
            </p>
          </div>

          {/* Link Columns */}
          <div className="flex-1 md:max-w-[480px] grid grid-cols-3 gap-8" data-id="element-20" data-mp="3v7q6hr3xkngk">
            <div data-id="element-21" data-mp="3v5n7ihksvjzp">
              <span className="block font-body text-[11px] uppercase tracking-[0.12em] text-arena/40 mb-4" data-id="element-22" data-mp="3q8n125k1gf82">
                SISTEMAS
              </span>
              <div className="flex flex-col gap-3" data-id="element-23" data-mp="81pdrea6qp79">
                {sistemasLinks.map(link => <a key={link.label} href={link.href} className="font-body text-[13px] text-arena/50 hover:text-arena/100 transition-opacity duration-150 no-underline" data-id="element-24" data-mp="33e5v93gaoro">
                    {link.label}
                  </a>)}
              </div>
            </div>
            <div data-id="element-25" data-mp="msg8ov72q4el">
              <span className="block font-body text-[11px] uppercase tracking-[0.12em] text-arena/40 mb-4" data-id="element-26" data-mp="msy1fhuj20hr">
                ORIGEN
              </span>
              <div className="flex flex-col gap-3" data-id="element-27" data-mp="tta0yjibn3yt">
                {origenLinks.map(link => <a key={link.label} href={link.href} className="font-body text-[13px] text-arena/50 hover:text-arena/100 transition-opacity duration-150 no-underline" data-id="element-28" data-mp="yruzmehxdfl5">
                    {link.label}
                  </a>)}
                <a href={getWhatsAppLink(FOOTER_WHATSAPP_MESSAGE)} target="_blank" rel="noopener noreferrer" className="font-body text-[13px] text-arena/50 hover:text-arena/100 transition-opacity duration-150 no-underline" data-id="element-29" data-mp="1hkfhl0w360a6">
                  Contacto
                </a>
              </div>
            </div>
            <div data-id="element-30" data-mp="3t9yhdnlg0e1l">
              <span className="block font-body text-[11px] uppercase tracking-[0.12em] text-arena/40 mb-4" data-id="element-31" data-mp="3t9gfaac3n5lr">
                LEGAL
              </span>
              <div className="flex flex-col gap-3" data-id="element-32" data-mp="2ah860yqtbewk">
                <span className="font-body text-[13px] text-arena/40 cursor-default" data-id="element-33" data-mp="25ncbk69rca65">
                  Privacidad
                </span>
                <span className="font-body text-[13px] text-arena/40 cursor-default" data-id="element-34" data-mp="21kpenqy8bz23">
                  Términos
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Line */}
        <div className="pt-6 border-t border-arena/10" data-id="element-35" data-mp="2pcnrwgh8o4hv">
          <p className="font-body text-[12px] text-arena/30" data-id="element-36" data-mp="2pcw8ojghftyc">
            © 2026 ORIGEN STUDIO · Colombia
          </p>
        </div>
      </div>
    </footer>;
}